import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = {
  key: 0,
  class: "titlebar-text"
}
const _hoisted_6 = {
  key: 1,
  style: {"font-size":"16px"},
  class: ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Ocorrência:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1)
const _hoisted_9 = { class: "titlebar-actions" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_11 = { class: "titlebar-actions-primary" }
const _hoisted_12 = {
  key: 0,
  class: "ui-button",
  type: "button"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Atualizar Status")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ui-button-content" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "ui-card-body" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_33 = { class: "ui-button-content" }
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "ant-row" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "ant-row" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_combo_usuario = _resolveComponent("combo-usuario")!
  const _component_combo_origem = _resolveComponent("combo-origem")!
  const _component_combo_tipo = _resolveComponent("combo-tipo")!
  const _component_combo_prioridade = _resolveComponent("combo-prioridade")!
  const _component_combo_pessoa = _resolveComponent("combo-pessoa")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_map_picker = _resolveComponent("map-picker")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_combo_lei_consideracao = _resolveComponent("combo-lei-consideracao")!
  const _component_ocorrencia_arquivo = _resolveComponent("ocorrencia-arquivo")!
  const _component_cadastro_pessoa_modal = _resolveComponent("cadastro-pessoa-modal")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state.ocorrencia.codigo === 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.state.ocorrencia.numero) + " ", 1),
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.servicoOcorrencia.obterNomeStatus(_ctx.state.ocorrencia.status)), 1)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_popover, {
            trigger: ['hover','click'],
            placement: "bottom"
          }, {
            content: _withCtx(() => [
              _createVNode(_component_a_space, {
                direction: "vertical",
                size: "small",
                style: {"min-width":"180px"}
              }, {
                default: _withCtx(() => [
                  ((_ctx.state.ocorrencia.status !== _ctx.EStatusOcorrencia.Aberta))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        block: "",
                        size: "small",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.atualizarStatus(_ctx.EStatusOcorrencia.Aberta)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Aberta ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.state.ocorrencia.status !== _ctx.EStatusOcorrencia.EmAtendimento))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        block: "",
                        size: "small",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.atualizarStatus(_ctx.EStatusOcorrencia.EmAtendimento)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Em Atendimento ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ((_ctx.state.ocorrencia.status !== _ctx.EStatusOcorrencia.Concluida))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        block: "",
                        size: "small",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.atualizarStatus(_ctx.EStatusOcorrencia.Concluida)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Concluída ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_popconfirm, {
                    title: "Cancelar este ocorrencia?",
                    "ok-text": "Sim",
                    "cancel-text": "Não",
                    onConfirm: _cache[3] || (_cache[3] = () => _ctx.atualizarStatus(_ctx.EStatusOcorrencia.Cancelada))
                  }, {
                    default: _withCtx(() => [
                      ((_ctx.state.ocorrencia.status !== _ctx.EStatusOcorrencia.Cancelada))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            block: "",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Cancelada ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              ((_ctx.state.ocorrencia.codigo > 0 && !_ctx.state.gerandoPdf))
                ? (_openBlock(), _createElementBlock("button", _hoisted_12, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.state.gerarPdf)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                class: "ui-button",
                loading: _ctx.state.gerandoPdf,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gerarPdf()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.state.gerandoPdf? 'Aguarde por favor... Estamos gerando o seu PDF': 'Gerar PDF'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (!_ctx.state.gerandoPdf)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "ui-button -primary",
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.salvar()))
              }, _hoisted_17))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              class: "ui-card",
              key: 'OCOR' + _ctx.state.ocorrencia.codigo
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "Data Registro" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.ocorrencia.data,
                          "onUpdate:dataSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.ocorrencia.data) = $event)),
                          "hora-minuto": true,
                          disabled: ""
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Responsável pelo Registro" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_usuario, {
                          codigo: _ctx.state.ocorrencia.codigoUsuarioRegistro,
                          "onUpdate:codigo": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.ocorrencia.codigoUsuarioRegistro) = $event)),
                          disabled: true
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, {
                      label: "Origem",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_origem, {
                          codigo: _ctx.state.ocorrencia.codigoOrigem,
                          "onUpdate:codigo": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.ocorrencia.codigoOrigem) = $event)),
                          disabled: _ctx.state.bloquearCampos,
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.marcarAlterado()))
                        }, null, 8, ["codigo", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_a_form_item, { label: "Data Vistoria" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.ocorrencia.dataVistoria,
                          "onUpdate:dataSelecionada": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.ocorrencia.dataVistoria) = $event)),
                          "hora-minuto": true,
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.marcarAlterado()))
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_a_form_item, {
                      label: "Agente Principal",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_usuario, {
                          codigo: _ctx.state.ocorrencia.codigoAgentePrincipal,
                          "onUpdate:codigo": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.ocorrencia.codigoAgentePrincipal) = $event)),
                          disabled: _ctx.state.bloquearCampos,
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.marcarAlterado()))
                        }, null, 8, ["codigo", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_a_form_item, { label: "Agente Apoio" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_usuario, {
                          codigo: _ctx.state.ocorrencia.codigoAgenteApoio,
                          "onUpdate:codigo": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.ocorrencia.codigoAgenteApoio) = $event)),
                          disabled: _ctx.state.bloquearCampos,
                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.marcarAlterado()))
                        }, null, 8, ["codigo", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_tipo, {
                          codigo: _ctx.state.ocorrencia.codigoTipo,
                          "onUpdate:codigo": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.ocorrencia.codigoTipo) = $event)),
                          disabled: _ctx.state.bloquearCampos,
                          onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.estrategiaAlteracaoTipo()))
                        }, null, 8, ["codigo", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_a_form_item, {
                      label: "Prioridade",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_prioridade, {
                          codigo: _ctx.state.ocorrencia.codigoPrioridade,
                          "onUpdate:codigo": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.ocorrencia.codigoPrioridade) = $event)),
                          disabled: _ctx.state.bloquearCampos,
                          onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.marcarAlterado()))
                        }, null, 8, ["codigo", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_card, { titulo: "SOLICITANTE" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_combo_pessoa, {
                          codigo: _ctx.state.ocorrencia.codigoCadastro,
                          "onUpdate:codigo": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.ocorrencia.codigoCadastro) = $event)),
                          disabled: _ctx.state.bloquearCampos,
                          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.marcarAlterado()))
                        }, null, 8, ["codigo", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("button", {
                          class: "ui-button -primary ui-full",
                          type: "button",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.apresentarCadastroPessoa = true))
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.obtemCodigoCadastro() >0?'Visualizar Cadastro':'Cadastrar pessoa'), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(_component_a_tabs, {
                      activeKey: _ctx.state.abaEnderecoLocalizacao,
                      "onUpdate:activeKey": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.abaEnderecoLocalizacao) = $event)),
                      onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.apresentarMapa()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "1",
                          tab: "ENDEREÇO"
                        }, {
                          default: _withCtx(() => [
                            ((_ctx.state.apresentarCampos))
                              ? (_openBlock(), _createBlock(_component_card, {
                                  key: 0,
                                  titulo: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createVNode(_component_a_form_item, { label: "CEP" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_cep, {
                                              onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.consultaCep())),
                                              valor: _ctx.state.ocorrencia.endereco.cep,
                                              "onUpdate:valor": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.ocorrencia.endereco.cep) = $event)),
                                              disabled: _ctx.state.bloquearCampos,
                                              onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 8, ["valor", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_36, [
                                        _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.ocorrencia.endereco.enderecoCompleto) = $event)),
                                              disabled: _ctx.state.bloquearCampos,
                                              onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 40, _hoisted_37), [
                                              [_vModelText, _ctx.state.ocorrencia.endereco.enderecoCompleto]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_38, [
                                        _createVNode(_component_a_form_item, { label: "Número" }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.ocorrencia.endereco.numero) = $event)),
                                              disabled: _ctx.state.bloquearCampos,
                                              onInput: _cache[29] || (_cache[29] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 40, _hoisted_39), [
                                              [_vModelText, _ctx.state.ocorrencia.endereco.numero]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createVNode(_component_a_form_item, { label: "Complemento" }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.ocorrencia.endereco.complemento) = $event)),
                                              disabled: _ctx.state.bloquearCampos,
                                              onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 40, _hoisted_42), [
                                              [_vModelText, _ctx.state.ocorrencia.endereco.complemento]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_43, [
                                        _createVNode(_component_a_form_item, {
                                          label: "Bairro",
                                          required: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.ocorrencia.endereco.bairro) = $event)),
                                              disabled: _ctx.state.bloquearCampos,
                                              onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 40, _hoisted_44), [
                                              [_vModelText, _ctx.state.ocorrencia.endereco.bairro]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_45, [
                                        _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_combo_cidade, {
                                              codigo: _ctx.state.ocorrencia.endereco.codigoCidade,
                                              "onUpdate:codigo": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.ocorrencia.endereco.codigoCidade) = $event)),
                                              disabled: _ctx.state.bloquearCampos,
                                              onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 8, ["codigo", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        _createVNode(_component_a_form_item, { label: "Ponto de referência" }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "ant-input",
                                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.ocorrencia.endereco.pontoReferencia) = $event)),
                                              disabled: _ctx.state.bloquearCampos,
                                              onInput: _cache[37] || (_cache[37] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 40, _hoisted_48), [
                                              [_vModelText, _ctx.state.ocorrencia.endereco.pontoReferencia]
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "2",
                          tab: "LOCALIZAÇÃO"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_map_picker, {
                              lat: _ctx.state.ocorrencia.endereco.latitude,
                              lng: _ctx.state.ocorrencia.endereco.longitude,
                              "onUpdate:lat": _cache[38] || (_cache[38] = val => (_ctx.state.ocorrencia.endereco.latitude = val)),
                              "onUpdate:lng": _cache[39] || (_cache[39] = val => (_ctx.state.ocorrencia.endereco.longitude = val))
                            }, null, 8, ["lat", "lng"]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createVNode(_component_a_form_item, { label: "Latitude" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.ocorrencia.endereco.latitude) = $event)),
                                      disabled: _ctx.state.bloquearCampos,
                                      onInput: _cache[41] || (_cache[41] = ($event: any) => (_ctx.marcarAlterado()))
                                    }, null, 40, _hoisted_51), [
                                      [_vModelText, _ctx.state.ocorrencia.endereco.latitude]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _createVNode(_component_a_form_item, { label: "Longitude" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.ocorrencia.endereco.longitude) = $event)),
                                      disabled: _ctx.state.bloquearCampos,
                                      onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.marcarAlterado()))
                                    }, null, 40, _hoisted_53), [
                                      [_vModelText, _ctx.state.ocorrencia.endereco.longitude]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["activeKey"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "VISTORIA" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tabs, {
                      activeKey: _ctx.state.abaVistoria,
                      "onUpdate:activeKey": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.state.abaVistoria) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "1",
                          tab: "DETALHES"
                        }, {
                          default: _withCtx(() => [
                            ((_ctx.state.apresentarCampos))
                              ? (_openBlock(), _createBlock(_component_card, {
                                  key: 0,
                                  titulo: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("div", _hoisted_55, [
                                        _createVNode(_component_a_form_item, { label: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_editor_html, {
                                              value: _ctx.state.ocorrencia.descricao,
                                              "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.state.ocorrencia.descricao) = $event)),
                                              onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.marcarAlterado()))
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _createVNode(_component_a_form_item, { label: "LEI/CONSIDERAÇÕES" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_combo_lei_consideracao, {
                                            codigo: _ctx.state.ocorrencia.codigoLeiConsideracao,
                                            "onUpdate:codigo": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.state.ocorrencia.codigoLeiConsideracao) = $event)),
                                            disabled: _ctx.state.bloquearCampos,
                                            onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.marcarAlterado()))
                                          }, null, 8, ["codigo", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "2",
                          tab: "ARQUIVOS"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.state.apresentarCampos)
                              ? (_openBlock(), _createBlock(_component_ocorrencia_arquivo, {
                                  key: 'ARQV'+ _ctx.state.ocorrencia.codigo + _ctx.state.ocorrencia.data,
                                  arquivos: _ctx.state.ocorrencia.arquivos,
                                  "onUpdate:arquivos": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.state.ocorrencia.arquivos) = $event)),
                                  onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.marcarAlterado()))
                                }, null, 8, ["arquivos"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["activeKey"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_cadastro_pessoa_modal, {
                  visivel: _ctx.state.apresentarCadastroPessoa,
                  "onUpdate:visivel": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.state.apresentarCadastroPessoa) = $event)),
                  codigoCadastro: _ctx.obtemCodigoCadastro(),
                  onOperacaoConcluida: _ctx.cadastroAtualizado
                }, null, 8, ["visivel", "codigoCadastro", "onOperacaoConcluida"])
              ])
            ]))
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}